import React, { useState } from "react";
import Searchbar from "../../Helpers/Searchbar/Searchbar";
import { useContext } from "react";
import { filtrationcontext } from "../../../context/Filtercontext";
import trans from "../../../utils";

export default function NotificationHead() {
  const { setSearchQuery } = useContext(filtrationcontext);
  const [query, setQuery] = useState("");
  const handleSearch = (e) => {
    setQuery(e.target.value);
    setSearchQuery(e.target.value);
  };
  return (
    <>
      <div className="bg-white p-16 ">
        <div className="flex-between">
          <Searchbar
            // eslint-disable-next-line react/style-prop-object
            style="search search-dark input-group"
            path={`${process.env.PUBLIC_URL}/assets/Search.svg`}
            placeholder={trans("Search")}
            value={query}
            onChange={handleSearch}
          />
        </div>
      </div>
    </>
  );
}
